import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { Badge } from "../components/ui/badge";
import api, { fmtDate } from "../lib/api";

const isActive = (date) => {
  const d = new Date(date + "T00:00:00");
  return (Date.now() - d.getTime()) / 86400000 <= 7;
};

const getSeen = () => {
  try { return JSON.parse(localStorage.getItem("vtz_seen_releases") || "[]"); } catch { return []; }
};

export default function NewsPage() {
  const [releases, setReleases] = useState(null);
  const seen = getSeen();

  useEffect(() => {
    api.get("/releases").then((r) => setReleases(r.data.history || [])).catch(() => setReleases([]));
  }, []);

  if (!releases) return <p className="text-sm text-[#475569]">Učitavanje...</p>;

  return (
    <div className="space-y-6 fade-up" data-testid="news-page">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B] mb-1">Povijest objava</p>
        <h1 className="font-heading text-4xl font-bold tracking-tight text-[#0F172A]">Novosti</h1>
        <p className="text-sm text-[#475569] mt-2">Sve dosadašnje novosti u aplikaciji, od najnovije prema starijima.</p>
      </div>

      {releases.length === 0 && (
        <div className="bg-white border border-dashed border-[#CBD5E1] rounded-sm p-10 text-center text-sm text-[#64748B]" data-testid="news-empty-state">
          <Megaphone className="w-8 h-8 mx-auto mb-3 text-[#CBD5E1]" />
          Još nema objavljenih novosti.
        </div>
      )}

      <div className="space-y-4 max-w-3xl">
        {releases.map((r, i) => (
          <div key={r.id} data-testid={`news-release-${i}`} className="bg-white border border-[#E2E8F0] rounded-sm p-5">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="flex items-center gap-2.5 min-w-0">
                <Megaphone className="w-4 h-4 text-[#0D9488] shrink-0" />
                <h2 className="font-heading text-lg font-semibold text-[#0F172A]">{r.title}</h2>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                {i === 0 && isActive(r.date) && !seen.includes(r.id) && (
                  <Badge data-testid={`news-active-badge-${i}`} className="rounded-sm text-[11px] bg-[#0D9488]/10 text-[#0D9488] hover:bg-[#0D9488]/10">Novo</Badge>
                )}
                <span className="text-xs text-[#64748B] tabular-nums">{fmtDate(r.date)}</span>
              </div>
            </div>
            <ul className="mt-3 space-y-1.5">
              {r.items.map((it, j) => (
                <li key={j} className="text-sm text-[#374857] flex gap-2">
                  <span className="text-[#0D9488] font-bold shrink-0">•</span>
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
